import { BASE_URL } from "@constants/common";
import { Product } from "@typings/product/product";

export const transformCartItemsToUrl = (cartItems: Product[]) => {
  return `${BASE_URL}/cart/?products=${encodeURIComponent(JSON.stringify(cartItems))}`;
};
